import styled from 'styled-components';

export const TagUserTypeStyles = styled.div<{ $primaryColor: string }>`
  padding: 2px 8px;
  color: ${({ $primaryColor }) => $primaryColor};
  background-color: ${({ $primaryColor }) => $primaryColor}25;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;
